export default __webpack_public_path__ + "img/ac2973298f701e27e8749de6d42b205e.svg";